export const SESSION_REPLACED_CODE = 'SESSION_REPLACED';
export const SESSION_REPLACED_REASON = 'session_replaced';
export const SESSION_REPLACED_MESSAGE =
    'You were signed out because your account was signed in on another device. Please sign in again.';

let sessionReplacedHandler = null;
let requested = false;
let started = false;

const start = () => {
    if (!sessionReplacedHandler || started) {
        return;
    }

    started = true;
    sessionReplacedHandler();
};

export const registerSessionReplaced = fn => {
    sessionReplacedHandler = fn;

    if (requested) {
        start();
    }
};

export const sessionReplaced = () => {
    requested = true;
    start();
};

export const isSessionReplaced = () => requested;
